
import { defineComponent, onActivated, onMounted, ref, watch } from 'vue'
import { CommonDialog, AdminTableLayout, ReportTable } from '@/components/Common'
import {
  useDialogCommon,
  useReportTableShowColumn,
} from '@/hooks'
import { FileUploadAgain, GetDownloadList, GetPrivateFile } from '@/api-server/modules/defaultServer'

import { tableColumn } from './downloadTableColumn'
import { ElMessage, ElMessageBox } from 'element-plus'

export default defineComponent({
  props: {
    visible: { type: Boolean, default: false },
    formData: {
      type: Object,
      default: () => ({}),
    },
  },

  components: {
    CommonDialog,
    AdminTableLayout,
    ReportTable,
  },

  emits: ['update:visible'],

  setup(props, context) {
    const { visibleRef } = useDialogCommon(props, context)
    const tableData = ref<BUSINESS_SERVE_PLATFORM_PC.GetDirectSaleCustomerListResponseDataItem[]>([])
    const loading = ref(false)

    const { showTableColumn } = useReportTableShowColumn(tableColumn)

    const requestTableData = async () => {
        loading.value = true
        const { data: { data }} = await GetDownloadList.fetch({ ...props.formData  })
        tableData.value = data as BUSINESS_SERVE_PLATFORM_PC.GetDownloadListResponseDataItem[]
        loading.value = false
    }

   const getPrivateUrl = async (imgUrl: string) => {
      const postData: BUSINESS_SERVE_PLATFORM_PC.GetPrivateFileRequestBody = {
        file_name: imgUrl,
      }
      const {
        data: { data: privateResult },
      } = await GetPrivateFile.fetch(postData);
      return privateResult;
    }

    const handleDownload = async (row: any) => {
      if (row.fileNameList.length <=0 || !row.fileNameList[0] ) return ElMessage.warning({ showClose: true, message: '下载失败' })
      const priviewUrl = await getPrivateUrl(row.fileNameList[0]);
      window.open(priviewUrl)
    }

    const handleReExport = async (row: any) => {
      await ElMessageBox.confirm(
        "是否确认要重新导出",
        "提示",
        {
          cancelButtonText: "取消",
          confirmButtonText: "确认",
        }
      );
      await FileUploadAgain.fetch({
        id: row.id,
      })
      requestTableData()
      ElMessage.success({ showClose: true, message: "重新导出成功" })
    }

    watch(()=> visibleRef.value, (flag) => {
      flag && requestTableData()
    }, { immediate: true })

    return {
      loading,
      tableData,
      showTableColumn,
      visibleRef,
      handleDownload,
      handleReExport,
      requestTableData
    }
  },
})
